import React from "react";
import { HashLink } from "react-router-hash-link";
import { PopupButton } from "react-calendly";

const NavLinks = () => {
  return (
    <>
      <HashLink
        className="px-4 font-extrabold text-gray-500 hover:text-[#2f337c]"
        smooth
        to="/#about"
      >
        About
      </HashLink>
      <HashLink
        className="px-4 font-extrabold text-gray-500 hover:text-[#2f337c]"
        smooth
        to="/#services"
      >
        Services
      </HashLink>
      <HashLink
        className="px-4 font-extrabold text-gray-500 hover:text-[#2f337c]"
        to="/#portfolio"
      >
        Products
      </HashLink>
      <HashLink
        className="px-4 font-extrabold text-gray-500 hover:text-[#2f337c]"
        to="/contact#contact"
      >
        Contact Us
      </HashLink>
      <PopupButton
        className="text-white bg-[#4d79bd] hover:bg-[#2f337c] inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl"
        url="https://calendly.com/devprodigeeit/"
        /*
         * react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
         * specify the rootElement property to ensure that the modal is inserted into the correct domNode.
         */
        rootElement={document.getElementById("root")}
        text="Schedule Meeting"
      />
    </>
  );
};

export default NavLinks;
